import { Product } from '../models/product.model';
import { AmberError } from 'src/app/snatch/models/amber-response.model';
import { ProductVariantShort } from "../../common/common-product/models/product-short.model";
import {IPageable} from "../../snatch/models/page.model";

export class ClearProductDetailsState {
    static readonly type = '[Product Details] Clear State';
    constructor() { }
}
export class GetProductDetails {
    static readonly type = '[Product Details] GetProductDetails';
    constructor(public sku: string) { }
}

export class GetProductRelatedBundles {
    static readonly type = '[Product Details] Get Product Related Bundles';
    constructor(public sku: string, public pageable: IPageable) { }
}

export class SetProductRelatedBundlesPagination {
    static readonly type = '[Product Details] Set Product Related Bundles Pageable Params';
    constructor(public pageable: IPageable) { }
}

export class GetIncludedProducts {
    static readonly type = '[Product Details] Get Included Products';
    constructor(public sku: string, public pageable: IPageable) { }
}

export class SetIncludedProductsPagination {
    static readonly type = '[Product Details] Set Included Products Pageable Params';
    constructor(public pageable: IPageable) { }
}

export class GetRelatedProducts {
    static readonly type = '[Product Details] Get related products';
    constructor(public sku: string, public limit?: number) { }
}
export class GetRelatedProductsSuccess {
    static readonly type = '[Product Details] Get related products successful';
    constructor(public products: Array<any>) { }
}
export class GetRelatedProductsError {
    static readonly type = '[Product Details] Get related products error';
    constructor(public error: AmberError) { }
}
export class GetProductDetailsSuccess {
    static readonly type = '[Product Details] GetProductDetails success';
    constructor(public payload: Product) { }
}
export class GetProductDetailsFailure {
    static readonly type = '[Product Details] GetProductDetails failure';
    constructor(public payload: AmberError) { }
}
export class GetProductVariantDeliverable {
    static readonly type = '[Product Details] GetProductVariantDeliverable';
    constructor(public sku: string) { }
}

export class GetProductVariantDeliverableSuccess {
    static readonly type = '[Product Details] GetProductVariantDeliverable success';
    constructor(public sku: string, public deliverables: any) { }
}

export class GetProductVariantDeliverableFailure {
    static readonly type = '[Product Details] GetProductVariantDeliverable failure';
    constructor(public payload: AmberError) { }
}

export class ToggleTab {
    static readonly type = '[Product Details] Toggle Tab';
    constructor(public readonly key: any) { }
}

export class RestoreState {
    static readonly type = '[Product Details] Restore State';
    constructor() { }
}

export class OnChangeVariantForm {
    static readonly type = '[Product Details] On Change Variant Form';
    constructor() { }
}

export class OnChangeBundleVariantForm {
    static readonly type = '[Product Details] On Change Bundle Variant Form';
    constructor() { }
}

export class OnSelectedVariantChange {
    static readonly type = '[Product Details] On Selected Variant Form';
    constructor(public variant: ProductVariantShort) { }
}

export class SelectProductVariant {
    static readonly type = '[Product Details] Override product variant selection';
    constructor(public language: string, public deliveryFormat: string, public certificateType: string, public license: string) { }
}

export class SelectedVariantQuantityChange {
    static readonly type = '[Product Details] On Selected Variant quantity change';
    constructor(public sku: string, public quantity: number) { }
}

export class ComputePriceForOrderTemplate {
    static readonly type = '[Product Details] Compute price for selected product for order templates';
    constructor(public sku: string, public quantity: number) { }
}

export class RequestEvaluationCopy {
    static readonly type = '[Product Details] On Request Evaluation Copy';
    constructor(public sku: string, public email: string) { }
}

export class RequestEvaluationCopySuccess {
    static readonly type = '[Product Details] On Request Evaluation Copy Success';
    constructor(public payload: any) { }
}

export class RequestEvaluationCopyError {
    static readonly type = '[Product Details] On Request Evaluation Copy Error';
    constructor(public payload: AmberError) { }
}
export class GetAccess {
    static readonly type = '[Product Details] Get Access';
    constructor(public segment: string) { }
}

export class CheckSegments {
    static readonly type = '[Product Details] Check Segments';
    constructor(public segments: string[]) { }
}

export class FetchOrderTemplatesMin {
    static readonly type = '[Product Details] Fetch all the order templates minimal info';
    constructor() { }
}

export class FetchOrderTemplatesMinSuccess {
    static readonly type = '[Product Details] Fetch all the order templates minimal info- success';
    constructor(public orderTemplates: Array<any>) { }
}

export class FetchOrderTemplatesMinError {
    static readonly type = '[Product Details] Fetch all the order templates minimal info- error';
    constructor(public error: AmberError) { }
}
export class CreateOrderTemplate {
    static readonly type = '[Product Details] Create Order Template';
    constructor(public name: string) { }
}

export class AddOrderTemplateItem {
    static readonly type = '[Product Details] Add Order Template Item';
    constructor(public payload: { sku: string, quantity: number, orderTemplate: string }) { }
}

export class UpdateProductDetails {
    static readonly type = '[Product Details] Update Product Details';
    constructor(public payload: Partial<Product>) { }
}
